<script lang="ts">
import { type Component } from 'vue';
import MainLayout from '@/layouts/main.vue';
import { socketInit } from '@/api/socket';
import { mapActions, mapState } from 'pinia';
import { useStatusStore } from '@/stores/status';
import { useAppStore } from '@/stores/app';
import Login from '@/pages/login.vue';
import CustomToast from '@/components/custom-toast.vue';

export default {
  name: 'AdminPanel',
  components: { MainLayout, Login, CustomToast },
  computed: {
    ...mapState(useAppStore, ['token']),
  },
  methods: {
    ...mapActions(useStatusStore, ['handleSocketMessage', 'handleRabbitMessage']),
    ...mapActions(useAppStore, ['setToken']),
    initSockets() {
      socketInit((event: string, message: string) => {
        switch (event) {
          case 'service-status':
            this.handleSocketMessage(JSON.parse(message));
            break;
          case 'rabbitmq-status':
            this.handleRabbitMessage(JSON.parse(message));
            break;
        }
      });
    },
  },
  mounted() {
    this.setToken(this.token).then(() => {
      this.initSockets();
    });
  },
  watch: {
    token(v) {
      if (v) {
        this.initSockets();
      }
    },
  },
} as Component;
</script>

<template>
  <CustomToast />
  <template v-if="token">
    <MainLayout />
  </template>
  <template v-else>
    <Login />
  </template>
</template>

<style lang="scss"></style>
